import Badge from "../../components/Badge";
import Avatar from 'react-avatar';
import ActionButton from "./ActionButton";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState} from "react";
import {Link} from "react-router-dom";
import AddOnProductStockModal from "./AddOnProductStockModal";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";
import NoneValue from "../../components/NoneValue";

function AddOnProduct({addOnProduct}) {
    const [addOnProductDetailsModal, setAddOnProductDetailsModal] = useState(false);
    const addOnProductDetailsModalToggle = () => setAddOnProductDetailsModal(!addOnProductDetailsModal);
    const [addOnProductStockHistoryModal, setAddOnProductStockHistoryModal] = useState(false);
    const addOnProductStockHistoryModaltoggle = () => setAddOnProductStockHistoryModal(!addOnProductStockHistoryModal);
    const [expandedProducts, setExpandedProducts] = useState(false);

    const toggleExpansion = () => {
        setExpandedProducts(!expandedProducts);
    };
    const visibleProducts = addOnProduct.products.slice(0, 3);
    const hiddenProductsCount = Math.max(addOnProduct.products.length - 3, 0);

    return (
        <>
            <tr>
                <td>
                    {addOnProduct.image ? <img src={addOnProduct.image}
                                          className="avatar-sm img-thumbnail rounded-circle" alt={"addOnProduct"}/>
                        : <Avatar size={35} name={addOnProduct.name} round/>}
                </td>
                <td onClick={addOnProductDetailsModalToggle}>
                    <Link className="text-primary">{addOnProduct.name === null? <NoneValue/>: addOnProduct.name}</Link>
                </td>
                <td className="text-muted font-13">{addOnProduct.price === null? <NoneValue/>: addOnProduct.price}</td>
                {/*<td>{addOnProduct.products}</td>*/}
                <td style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {visibleProducts.map(product => (
                        <div key={product.id} title={product.name}>
                                {product.image ? (
                                    <img src={product.image} className="avatar-sm img-thumbnail rounded-circle" alt={product.name} />
                            ) : (
                            <Avatar size={35} name={product.name} round />
                            )}
                        </div>
                    ))}
                    <span className="badge badge-light-primary">{addOnProduct.products.length} items</span>
                    {
                        hiddenProductsCount > 0?
                        <span onClick={() => {
                         addOnProductDetailsModalToggle()
                         toggleExpansion()
                         }} style={{ cursor: 'pointer' }}>
                        <div
                           style={{
                           width: '35px',
                           height: '35px',
                           backgroundColor: 'grey',
                           borderRadius: '50%',
                           display: 'flex',
                           justifyContent: 'center',
                           alignItems: 'center',
                           color: 'white',
                           fontSize: '12px',
                           }}
                           title={addOnProduct.products.slice(3).map(product => product.name).join(', ')}
                        >
                          {`+${hiddenProductsCount}`}
                        </div>
                        </span>
                        : null
                    }
                </td>

                <td>
                    <Badge badge={
                        addOnProduct.status === "ACTIVE"
                            ? "badge badge-light-success"
                            : "badge badge-light-danger"
                    } status={addOnProduct.status === null? <NoneValue/>: addOnProduct.status}/>
                </td>
                <td>{addOnProduct.stock === null? <NoneValue/>: addOnProduct.stock}</td>
                <td>{addOnProduct.is_inventory_tracking_enabled? <i className="mdi mdi-check mr-2 font-18 text-success"/>: <i className="mdi mdi-close mr-2 font-18 text-danger"/>}</td>
                {/*<td>{addOnProduct.tax === null? <NoneValue/>: addOnProduct.tax}</td>*/}
                <td>{new Date(addOnProduct.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                <ActionButton addOnProduct={addOnProduct}/>
            </tr>

            <Modal className={'modal-xl'} isOpen={addOnProductDetailsModal} toggle={addOnProductDetailsModalToggle}>
                <ModalHeader toggle={addOnProductDetailsModalToggle} close={
                    <button className="close" onClick={addOnProductDetailsModalToggle}>
                        &times;
                    </button>}>Add-On Product details: {addOnProduct.name}</ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        <h4 className="header-title">{addOnProduct.name === null? <NoneValue/>: addOnProduct.name}</h4>
                        <p className="sub-header">
                                {addOnProduct.image ? <img src={addOnProduct.image}
                                                      className="avatar-xl img-thumbnail rounded-circle" alt={"addOnProduct"}/>
                                    : <Avatar size={95} name={addOnProduct.name} round/>}
                        </p>
                        <div className="table-responsive">
                            <table className="table mb-0">
                                <tbody>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Add-On Product ID</td>
                                    <td>{addOnProduct.id === null ? <NoneValue/> : addOnProduct.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Add-On Product Name</td>
                                    <td>{addOnProduct.name === null ? <NoneValue/> : addOnProduct.name}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Price</td>
                                    <td>{addOnProduct.price === null ? <NoneValue/> : addOnProduct.price}</td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Price Before Tax</td>*/}
                                {/*    <td>{addOnProduct.price_before_tax === null ? <NoneValue/> : addOnProduct.price_before_tax}</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Price After Tax</td>*/}
                                {/*    <td>{addOnProduct.price_after_tax === null ? <NoneValue/> : addOnProduct.price_after_tax}</td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"></th>
                                    <td>Description</td>
                                    <td>{addOnProduct.description === "" ?
                                        <NoneValue/> : addOnProduct.description}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Products Supported</td>
                                    <td>
                                        <div className="mb-2">
                                            <span className="badge badge-light-primary">{addOnProduct.products.length} items</span>
                                        </div>
                                        <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                                        {addOnProduct.products.slice(0, 4).map((product, index) => (
                                            <div key={product.id} title={product.name} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <span style={{ minWidth: '24px' }}>{index + 1}.</span>
                                                {product.image ? (
                                                    <img src={product.image} className="avatar-sm img-thumbnail rounded-circle" alt={product.name} />
                                                ) : (
                                                    <Avatar size={35} name={product.name} round />
                                                )}
                                                <span>{product.name}</span>
                                            </div>
                                        ))}
                                        {addOnProduct.products.length > 4 && (
                                            <>
                                                {expandedProducts
                                                    ? addOnProduct.products.slice(4).map((product, index) => (
                                                        <div key={product.id} title={product.name} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <span style={{ minWidth: '24px' }}>{index + 5}.</span>
                                                            {product.image ? (
                                                                <img src={product.image} className="avatar-sm img-thumbnail rounded-circle" alt={product.name} />
                                                            ) : (
                                                                <Avatar size={35} name={product.name} round />
                                                            )}
                                                            <span>{product.name}</span>
                                                        </div>
                                                    ))
                                                    : null}
                                                <span onClick={toggleExpansion} style={{cursor: 'pointer'}}>
                                                <div
                                                    style={{
                                                        width: '35px',
                                                        height: '35px',
                                                        backgroundColor: 'grey',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        color: 'white',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    {addOnProduct.products.length > 4 && !expandedProducts ? `+${addOnProduct.products.length - 4}` : "-"}
                                                </div>
                                              </span>
                                            </>
                                        )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Inventory Tracking Enabled</td>
                                    <td>{addOnProduct.is_inventory_tracking_enabled ?
                                        <i className="mdi mdi-check mr-2 font-18 text-success"/> :
                                        <i className="mdi mdi-close mr-2 font-18 text-danger"/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Stock</td>
                                    <td>
                                        {addOnProduct.stock !== null ? (
                                            <>
                                                {addOnProduct.stock}
                                                <Button
                                                    onClick={addOnProductStockHistoryModaltoggle}
                                                    color="#4d5bed"
                                                    className='bx-btn-primary ml-2'
                                                >
                                                    View Stock History
                                                </Button>
                                            </>
                                        ) : (
                                            <Button
                                                onClick={addOnProductStockHistoryModaltoggle}
                                                color="#4d5bed"
                                                className='bx-btn-primary'
                                            >
                                                View Stock History
                                            </Button>
                                        )}
                                    </td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Tax Type</td>*/}
                                {/*    <td>{addOnProduct.tax_type === null ? <NoneValue/> : addOnProduct.tax_type}</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Tax Percentage</td>*/}
                                {/*    <td>{addOnProduct.tax_percentage === null ?*/}
                                {/*        <NoneValue/> : addOnProduct.tax_percentage} %</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Tax Amount</td>*/}
                                {/*    <td>{addOnProduct.tax_amount === null ?*/}
                                {/*        <NoneValue/> : addOnProduct.tax_amount}</td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"></th>
                                    <td>Status</td>
                                    <td><Badge badge={
                                        addOnProduct.status === "ACTIVE"
                                            ? "badge badge-light-success"
                                            : "badge badge-light-danger"
                                    } status={addOnProduct.status === null ? <NoneValue/> : addOnProduct.status}/></td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>UPC</td>
                                    <td>{addOnProduct.upc === "" ? <NoneValue/> : addOnProduct.upc}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Digital</td>
                                    <td>{addOnProduct.is_digital === true
                                        ? <i className="mdi mdi-check mr-2 font-18 text-success"/> :
                                        <i className="mdi mdi-close mr-2 font-18 text-danger"/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Created</td>
                                    <td>{new Date(addOnProduct.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Updated</td>
                                    <td>{new Date(addOnProduct.updated).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <AddOnProductStockModal addOnProduct={addOnProduct} modal={addOnProductStockHistoryModal}
                                    modalToggle={addOnProductStockHistoryModaltoggle}/>
        </>
    );
}

export default AddOnProduct;
